export default "__VITE_ASSET__jDulr91K__"